let api_token;

switch (window.Shopify.shop) {
  case "fostr-underscore.myshopify.com":
    api_token = "206fa93198662aeb44f1a671aa9f45f4"; // Dev Store
    break;
}

window.API_VERSION = "2023-10";
if(api_token) window.API_ACCESS = api_token;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  /*
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  */
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.icon = this.querySelector('.icon-play');
    if (!poster) {
      this.loadContent.bind(this)();
    } else {
      poster.addEventListener("click", this.loadContent.bind(this));
    }
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        setTimeout(() => {
          deferredElement.play();
        }, 1); // Play after 1 second
      }
    }
    if (this.icon) {
      this.icon.style.display = "none";
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    document
      .querySelectorAll(
        '.product-form__input input[type="radio"], .product-form__input select'
      )
      .forEach((option) =>
        option.addEventListener("change", this.whichInputUpdated.bind(option))
      );

    this.addEventListener("change", this.onVariantChange);

  }

  whichInputUpdated(element) {
    var optionname = element.target
      .closest(".product-form__input")
      .querySelector(".form__label").dataset.optionname;

    document
      .querySelectorAll(`.product-form__input`)
      .forEach((option) => option.classList.remove("activeset"));

    document
      .querySelectorAll(`.form__label[data-optionname="${optionname}"]`)
      .forEach((option) =>
        option.closest(".product-form__input").classList.add("activeset")
      );
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantsData();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateUpsellForms();
    this.updatePriceDiff();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    var allSelectors = document.querySelectorAll(
      ".section-main-product .product__variant-selector.option-select"
    );

    allSelectors.forEach((selector) => {
      if (selector != this) {
        this.updatePairUI(selector, this);
      }
    });
  }

  updateUpsellForms() {
    const upsellForms = document.querySelectorAll('.js-product-upsells');

    document.dispatchEvent(new Event('upsells:reset'));

    upsellForms.forEach((el) => {
      el.classList.remove('active');

      if (el.dataset.upsellVariantId == this.currentVariant.id) {
        el.classList.add('active');
      }
    })
  }

  updatePriceDiff() {
    const priceDiff = document.querySelectorAll('.js-price-diff');

    priceDiff.forEach((el) => {
      const variantPrice = parseInt(el.dataset.diffMessageVariantPrice);

      let message = Shopify.formatMoney(0, window.money.format);

      if (!variantPrice || isNaN(variantPrice)) return;

      const diff = this.currentVariant.price - variantPrice;

      const priceDiff = Shopify.formatMoney(Math.abs(diff), window.money.format);

      if (diff > 0) {
        message = `${window.productStrings.saveExtra}${priceDiff}`;
      } else if(diff < 0) {
        message = `+ ${priceDiff}`;
      } else {
        message = `+ ${message}`;
      }

      el.innerText = message;
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}-${this.dataset.product}, #product-form-installment-${this.dataset.section}-${this.dataset.product}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}-${this.dataset.product}`
        );

        const destinationSticky = document.querySelectorAll(`.price-${this.dataset.section}-support .sticky-atc__price`);
        const destinationStickySaving = document.querySelectorAll(`.price-${this.dataset.section}-support .sticky-atc__saving`);
        const destinationLeadTime = document.querySelectorAll('.sticky-atc_delivery-msg');

        const destinationUpsells = document.getElementById('product-upsells-wrapper');
        const sourceUpsells = html.getElementById(`product-upsells-wrapper`);

        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-${this.dataset.product}`
        );

        const sourceAtc = html.querySelector(
          `#price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-${this.dataset.product} .price__regular .price-item.price-item--regular`
        )?.innerHTML;

        const sourceSaving = html.querySelector(
          `#price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-${this.dataset.product} .price__sale .price__saving`
        );

        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-${this.dataset.product}`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}-${this.dataset.product}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-${this.dataset.product}`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}-${this.dataset.product}`
        );

        const leadTimeSource = html.querySelector(
          `#lead-time-msg-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const leadTimeDestination = document.getElementById(
          `lead-time-msg-${this.dataset.section}`
        );

        const preOrderSource = html.querySelector(
          `#ProductSubmitButton-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )?.dataset.preorder;

        const preOrderDestination = document.getElementById(
          `ProductSubmitButton-${this.dataset.section}`
        );

        if (preOrderSource && preOrderDestination) {
          preOrderDestination.dataset.preorder = preOrderSource;
        }

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceAtc && destinationSticky.length > 0) {
          let price = sourceAtc;

          destinationSticky.forEach((sticky) => {
            sticky.innerHTML = price;
          });
        }

        if (sourceSaving && destinationStickySaving.length > 0) {
          const saving = parseInt(sourceSaving.dataset.saving) > 0 ? sourceSaving.innerHTML : '';

          destinationStickySaving.forEach((sticky) => {
            sticky.innerHTML = saving;
          });
        }

        if (leadTimeSource && destinationLeadTime.length > 0) {
          destinationLeadTime.forEach((leadTime) => {
            leadTime.innerHTML = leadTimeSource.innerHTML;
          });
        }

        const leadTimeProperty = document.querySelector('input.product-form__pre-order');

        const productForm = document.getElementById(
          `product-form-${this.dataset.section}-${this.dataset.product}`
        );

        if (leadTimeSource && leadTimeSource.classList.contains('lead-time-msg--preorder')) {
            const input = document.createElement('input');
            input.className = 'product-form__pre-order';
            input.type = 'hidden';
            input.name = 'properties[Pre Order]';
            input.value = leadTimeSource.textContent;
            productForm.appendChild(input);
        } else if (leadTimeProperty) {
            leadTimeProperty.remove();
        }

        if (sourceUpsells && destinationUpsells) {
          destinationUpsells.innerHTML = sourceUpsells.innerHTML;
        } else if (!sourceUpsells && destinationUpsells) {
          // if there are no upsells in the new variant, insert an p elemtn with msg
          const noUpsells = document.createElement('p');
          noUpsells.innerHTML = 'No upsells available for this variant';
          destinationUpsells.innerHTML = '';
          destinationUpsells.appendChild(noUpsells);
        }

        this.resetUpsellsState();

        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        if (leadTimeSource && leadTimeDestination) {
          leadTimeDestination.replaceWith(leadTimeSource.cloneNode(true));
        }

        const price = document.getElementById(`price-${this.dataset.section}-${this.dataset.product}`);

        const priceSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        if (price) price.classList.remove("visibility-hidden");
        if (priceSticky) priceSticky.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}-${this.dataset.product}`
        );

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  resetUpsellsState() {
    // when variant are changed the upsells that are added to cart should be removed ans all states should be reset
    const addedUpsells = document.querySelectorAll('sticky-atc .upsells-drawer li');
    if(addedUpsells.length > 0){
      addedUpsells.forEach((upsell) => {
        upsell.remove();
      });
    }

    const upsellsCount = document.querySelector('sticky-atc > .sticky-atc__upsells .upsells_count');
    const upsellsAtc = document.querySelector('sticky-atc > .sticky-atc__upsells');

    if (upsellsCount && upsellsAtc) {
      upsellsCount.innerHTML = '0';
      upsellsAtc.classList.contains('hidden') ? '' : upsellsAtc.classList.add('hidden');
      upsellsAtc.hasAttribute("aria-hidden", "true") ? '' : upsellsAtc.setAttribute("aria-hidden", "true");
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}-${this.dataset.product}`
    );

    if (!productForm) return;

    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    if (!addButton) return;

    const preorder = addButton.dataset.preorder === "true";

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        if (addButtonSticky) addButtonTextSticky.textContent = text;
      }
    } else if (preorder) {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.preOrder;

      if (addButtonSticky) {
        addButtonSticky.removeAttribute("disabled");
        addButtonTextSticky.textContent = window.variantStrings.preOrder;
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;

      if (addButtonSticky) {
        addButtonSticky.removeAttribute("disabled");
        addButtonTextSticky.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}-${this.dataset.product}`
    );
    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    const price = document.getElementById(`price-${this.dataset.section}-${this.dataset.product}`);
    const priceSticky = document.getElementById(
      `price-${this.dataset.section}-support`
    );

    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}-${this.dataset.product}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}-${this.dataset.product}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (addButtonSticky)
      addButtonTextSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");

    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  updateVariantsData() {
    const fieldSets = Array.from(this.querySelectorAll("fieldset"));

    if(fieldSets.length != 2)return;

    const diffElements = Array.from(document.querySelectorAll(".js-price-diff"));
    if (!diffElements) return;
    const optionOneElements = diffElements?.filter(el => el.dataset.valueIndex == '1');
    const optionTwoElements = diffElements?.filter(el => el.dataset.valueIndex == '2');

    if (!optionOneElements || !optionTwoElements) return;

    const optionOne = this.currentVariant.options[0];
    const optionTwo = this.currentVariant.options[1];

    optionOneElements.forEach((el) => {
      const a = el?.getAttribute("data-variant-title")?.split(' / ')[0]?.trim();
      const b = el?.getAttribute("data-variant-title")?.split(' / ')[1]?.trim();

      if (!a || !b) return;

      if(b != optionTwo) {
        el.dataset.diffMessageVariantTitle = `${a} / ${optionTwo}`;
      }

      this.variantData.forEach((variant) => {
        if(variant.options[0] == a && variant.options[1] == optionTwo) {
          el.dataset.diffMessageVariantPrice = variant.price;
        }
      });
    });

    optionTwoElements.forEach((el) => {
      const a = el.getAttribute("data-variant-title").split(' / ')[0]?.trim();
      const b = el.getAttribute("data-variant-title").split(' / ')[1]?.trim();

      if(a != optionOne) {
        el.dataset.diffMessageVariantTitle = `${optionOne} / ${b}`;
      }

      this.variantData.forEach((variant) => {
        if(variant.options[0] == optionOne && variant.options[1] == b) {
          el.dataset.diffMessageVariantPrice = variant.price;
        }
      });
    });


  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePairUI(paired, original) {
    var originalTagName = original.tagName.toLowerCase();
    var pairedTagName = paired.tagName.toLowerCase();
    var originalSelectedItem = "";
    var originalSelectedItemValue = "";

    if (originalTagName.includes("selects")) {
      var itemSelect = original.querySelector(".activeset select");
      originalSelectedItem = itemSelect.options[itemSelect.selectedIndex];
      originalSelectedItemValue = originalSelectedItem.value;
    } else {
      originalSelectedItem = original.querySelector(
        '.activeset input[type="radio"]:checked'
      );
      originalSelectedItemValue = originalSelectedItem.value;
    }

    if (pairedTagName.includes("selects")) {
      var event = new Event("change");
      paired.querySelector(".activeset select").value =
        originalSelectedItemValue;
      paired
        .querySelector(
          `.activeset option[data-value="${originalSelectedItemValue}"`
        )
        .click();
      paired.dispatchEvent(event);
    } else {
      paired.querySelector(
        `.activeset input[type="radio"]:checked`
      ).checked = false;
      var newTarget = paired
        .querySelector(
          `.activeset label[data-value="${originalSelectedItemValue}"`
        )
        .getAttribute("for");
      paired.querySelector(
        `.activeset input[type="radio"]#${newTarget}`
      ).checked = true;
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class DetailsOpenState extends HTMLElement {
  constructor() {
    super();
    this.breakpointDesktop = window.matchMedia("(min-width: 750px)");
    this.breakpointMobile = window.matchMedia("(max-width: 749px)");
    this.details = this.querySelector("button.accordion-summary")
    this.OpenedOnDesktop = this.dataset.desktop || false
    this.OpenedOnMobile = this.dataset.mobile || false
  }

  connectedCallback() {
    this.open.bind(this)();
    this.breakpointDesktop.addEventListener("change", this.open.bind(this));
    this.breakpointMobile.addEventListener("change", this.open.bind(this));
  }

  open() {
    if (this.breakpointDesktop.matches) {
      this.details.setAttribute("aria-expanded", this.OpenedOnDesktop)
    } else if (this.breakpointMobile.matches) {
      this.details.setAttribute("aria-expanded", this.OpenedOnMobile)
    }
  }
}

customElements.define("details-open-state", DetailsOpenState);

class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.dataLayers(); // GTM Datalayer Tracking
  }

  dataLayers() {
    const category = this.dataset.collectionTitle || "";

    const products = [...this.querySelectorAll("product-card")].map((product) => {
      return {
        id: product.dataset.productId,
        name: product.dataset.productName,
        price: product.dataset.price,
        brand: product.dataset.vendor,
        category: category,
      };
    });

    dataLayer.push({
      event: 'eec.impressionView',
      ecommerce: {
        currencyCode: document.body.dataset.currencyCode,
        impressions: products,
      },
    });

    // console.info('GTM Datalayer: Products viewed', category);

    this.addEventListener("click", (event) => {
      const product = event.target.closest(".product-card");
      if (!product) return;

      const productData = {
        id: product.dataset.productId,
        name: product.dataset.productName,
        price: product.dataset.price,
        brand: product.dataset.vendor,
        category: category,
      };

      dataLayer.push({
        event: 'eec.impressionClick',
        ecommerce: {
          click: {
            actionField: { list: category },
            products: [productData]
          }
        }
      });

      // console.info('GTM Datalayer: Products clicked', category, productData.name);
    });
  }
}

customElements.define("product-grid", ProductGrid);

// smooth scroll to section
class SmoothScroll extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.addEventListener("click", this.scroll.bind(this));
  }

  scroll() {
    const section = document.getElementById(this.sectionId);
    if (!section) return;

    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}


customElements.define("smooth-scroll", SmoothScroll);

//explore collection link
class ExploreCollectionLink extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('a')
  }

  connectedCallback() {
    this.link.addEventListener('click', this.openCollection.bind(this))
  }

  openCollection(event) {
    event.preventDefault();
    window.location.href = `${this.link.href}?explore-tab=true`
  }
}

customElements.define("explore-collection-link", ExploreCollectionLink);